/* cc: Weicher Bildwechsel beim Tippen auf ein Vorschaubild am Handy (statt Scroll-Animation).
   Christian, 27.09.2026. Übernommen aus dem Lovenja-Theme (cc-media-fade.js vom 14.09.2026),
   hier nur der Teil für das Tippen auf Vorschaubilder: die DCB-Bücher haben je eine Variante.
   Technik: Vor dem Tausch legt sich eine Kopie des sichtbaren Bildes („Deckbild") über die
   Galerie. Darunter springt Dawn ohne Animation zum neuen Bild (.cc-media-jump). Sobald das
   neue Bild geladen und dekodiert ist, blendet das Deckbild aus.
   Wischen und Desktop bleiben unverändert; prefers-reduced-motion = harter Wechsel ohne Fade.
   Additiv: Klicks werden in der Capture-Phase vor Dawns Handler abgefangen. */
(function () {
  var GHOST_FADE_MS = 250;
  var DECODE_TIMEOUT_MS = 1500;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 749px)');

  function visibleItem(viewer) {
    if (mobile.matches && viewer.sliderItemsToShow && viewer.currentPage) {
      var shown = viewer.sliderItemsToShow[viewer.currentPage - 1];
      if (shown) return shown;
    }
    return viewer.querySelector('[data-media-id].is-active');
  }

  function makeGhost(viewer) {
    var item = visibleItem(viewer);
    var img = item && item.querySelector('.product__media img');
    if (!img || !img.complete || !img.naturalWidth) return null;
    var vr = viewer.getBoundingClientRect();
    var ir = img.getBoundingClientRect();
    if (!ir.width || !ir.height) return null;
    var cs = getComputedStyle(img);
    var ghost = img.cloneNode(false);
    ghost.className = 'cc-media-ghost';
    ghost.removeAttribute('id');
    ghost.removeAttribute('loading');
    ghost.removeAttribute('fetchpriority');
    ghost.setAttribute('alt', '');
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.cssText =
      'position:absolute;z-index:3;pointer-events:none;margin:0;max-width:none;' +
      'left:' + (ir.left - vr.left) + 'px;top:' + (ir.top - vr.top) + 'px;' +
      'width:' + ir.width + 'px;height:' + ir.height + 'px;' +
      'object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition + ';' +
      'border-radius:' + cs.borderRadius + ';opacity:1;' +
      'transition:opacity ' + GHOST_FADE_MS + 'ms ease;';
    viewer.appendChild(ghost);
    return ghost;
  }

  function waitForImage(img) {
    return new Promise(function (resolve) {
      if (!img) return resolve();
      var done = false;
      var finish = function () {
        if (!done) {
          done = true;
          resolve();
        }
      };
      var decodeThen = function () {
        if (img.decode) img.decode().then(finish, finish);
        else finish();
      };
      setTimeout(finish, DECODE_TIMEOUT_MS);
      if (img.complete && img.naturalWidth) return decodeThen();
      img.addEventListener('load', decodeThen, { once: true });
      img.addEventListener('error', finish, { once: true });
    });
  }

  function crossfade(viewer, swap) {
    var stale = viewer.querySelector('.cc-media-ghost');
    if (stale) stale.remove();
    var ghost = reducedMotion.matches ? null : makeGhost(viewer);

    viewer.classList.add('cc-media-jump');
    swap();
    setTimeout(function () {
      viewer.classList.remove('cc-media-jump');
    }, 50);

    if (!ghost) return;
    var next = viewer.querySelector('[data-media-id].is-active .product__media img');
    if (next && next.loading === 'lazy') next.loading = 'eager';
    waitForImage(next).then(function () {
      requestAnimationFrame(function () {
        ghost.style.opacity = '0';
        setTimeout(function () {
          ghost.remove();
        }, GHOST_FADE_MS + 50);
      });
    });
  }

  function hookMobileThumbnails() {
    Array.prototype.forEach.call(document.querySelectorAll('media-gallery'), function (gallery) {
      if (gallery.__ccMediaFade) return;
      gallery.__ccMediaFade = true;
      gallery.addEventListener(
        'click',
        function (event) {
          if (!mobile.matches) return;
          var button = event.target.closest('[id^="GalleryThumbnails"] [data-target] button');
          if (!button || !gallery.contains(button)) return;
          var mediaId = button.closest('[data-target]').dataset.target;
          var viewer = gallery.elements ? gallery.elements.viewer : null;
          if (!viewer) return;
          var target = viewer.querySelector('[data-media-id="' + mediaId + '"]');
          if (!target || target === visibleItem(viewer)) return;
          event.preventDefault();
          event.stopPropagation();
          crossfade(viewer, function () {
            gallery.setActiveMedia(mediaId, false);
          });
        },
        true
      );
    });
  }

  customElements.whenDefined('media-gallery').then(hookMobileThumbnails);
})();
